import React, { Component } from "react";

import { Steps, Icon, Tooltip } from "antd";

import "./ProgressSteps.css";
import { observer, inject } from "mobx-react";

@inject("registrationStore", "translationsStore")
@observer
export default class ProgressSteps extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  description(services) {
    return (
      <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
        {services.map((s, index) => {
          return <li key={`s_desc_${index}`}>{s}</li>;
        })}
      </ul>
    );
  }

  icon(iconType, description) {
    return (
      <Tooltip mouseLeaveDelay={0.1} title={this.description(description)}>
        <Icon type={iconType} />
      </Tooltip>
    );
  }

  render() {
    const {
      translationsStore: { current: t },
      registrationStore: { status }
    } = this.props;
    return (
      <Steps className="ProgressSteps">
        <Steps.Step
          status={status === 0 ? "process" : "finish"}
          icon={this.icon("hdd", [t["registration"]["step_0"]])}
        />
        <Steps.Step
          status={status === 1 ? "process" : status > 1 ? "finish" : "wait"}
          icon={this.icon("car", [t["registration"]["step_1"]])}
        />
        <Steps.Step
          status={status === 3 ? "process" : status > 3 ? "finish" : "wait"}
          icon={this.icon("setting", [t["registration"]["step_3_0"], t["registration"]["step_3_1"]])}
        />
        <Steps.Step
          status={status === 4 ? "process" : status > 4 ? "finish" : "wait"}
          icon={this.icon("credit-card", [t["registration"]["step_4"]])}
        />
        <Steps.Step
          status={status === 5 ? "process" : status > 5 ? "finish" : "wait"}
          icon={this.icon("sync", [t["registration"]["step_5_0"]])}
        />
        <Steps.Step
          status={status >= 5.1 && status < 6 ? "process" : status >= 6 ? "finish" : "wait"}
          icon={this.icon("cloud-upload-o", [t["registration"]["step_5_1"]])}
        />
        <Steps.Step
          status={status === 6 ? "process" : status > 6 ? "finish" : "wait"}
          icon={this.icon("trophy", [t["registration"]["step_6"]])}
        />
      </Steps>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/ProgressSteps/ProgressSteps.js